export default {
    methods: {
      getAppFlags(key) {
        return JSON.parse(localStorage.getItem(key)) || {};
      },

      setAppFlags(key, flags) {
        localStorage.setItem(key, JSON.stringify(flags));
      },
      
      setFlag(objectKey, flagKey, value) {
        let flags = this.getAppFlags(objectKey);
        flags[flagKey] = value;     
        this.setAppFlags(objectKey, flags);     
      },
      
      getFlag(objectKey, flagKey) {
        let flags = this.getAppFlags(objectKey);
        return flags[flagKey];
      },
      
      hasFlag(objectKey, flagKey) {
        let flags = this.getAppFlags(objectKey);
        return flags.hasOwnProperty(flagKey);
      },

      removeAppObject(objectKey) {
        localStorage.removeItem(objectKey);
      }
    }
  };
  